/*import {
    repo_menu_icon_link,
} from '../../Utils'*/

export default function SidebarData(props) {
    let pathver = false
    try {
        if (props.rotas !== undefined)
            pathver = false
    } catch {
        pathver = true
    }
    
    return [
        {
            id: '10',
            title: 'Painel Principal',
            title_lang: 'painel_principal',
            path: pathver ? ' ' : props.rotas.Main.view.endpoint,
            icon: 'house',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: []
        },
        {
            id: '15',
            title: 'Calendário',
            title_lang: 'calendar',
            path: pathver ? '' : props.rotas.Calendar_Event.view.endpoint,
            path_base: pathver ? '' : props.rotas.Calendar_Event.base,
            icon: 'calendar3',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: []
        },
        {
            id: '80',
            title: 'Concurso',
            title_lang: 'contest',
            path: pathver ? '' : props.rotas.Content_Contest.list.endpoint,
            path_base: pathver ? '' : props.rotas.Content_Contest.base,
            icon: 'archive',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '81',
                    title: 'Lista de Inscritos',
                    title_lang: 'contest_list',
                    path: pathver ? '' : props.rotas.Content_Contest.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Contest.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '82',
                    title: 'Novo Inscrito',
                    title_lang: 'contest_new',
                    path: pathver ? '' : props.rotas.Content_Contest.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Contest.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '83',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Content_Contest.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Contest.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '20',
            title: 'Conteúdo',
            title_lang: 'content',
            path: pathver ? '' : props.rotas.Content.list.endpoint,
            path_base: pathver ? '' : props.rotas.Content.base,
            icon: 'diagram-3',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '21',
                    title: 'Lista de Conteúdos',
                    title_lang: 'content_list',
                    path: pathver ? '' : props.rotas.Content.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Content.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '22',
                    title: 'Novo Conteúdo',
                    title_lang: 'content_new',
                    path: pathver ? '' : props.rotas.Content.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Content.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '23',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Content.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Content.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '40',
            title: 'Notícias',
            title_lang: 'articles',
            path: pathver ? '' : props.rotas.Content_News.list.endpoint,
            path_base: pathver ? '' : props.rotas.Content_News.base,
            icon: 'newspaper',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '41',
                    title: 'Lista de Notícias',
                    title_lang: 'articles_list',
                    path: pathver ? '' : props.rotas.Content_News.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_News.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '42',
                    title: 'Nova Notícia',
                    title_lang: 'article_new',
                    path: pathver ? '' : props.rotas.Content_News.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_News.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '43',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Content_News.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_News.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '50',
            title: 'Banners',
            title_lang: 'banners',
            path: pathver ? '' : props.rotas.Content_Banner.list.endpoint,
            path_base: pathver ? '' : props.rotas.Content_Banner.base,
            icon: 'images',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '51',
                    title: 'Lista de Banners',
                    title_lang: 'banners_list',
                    path: pathver ? '' : props.rotas.Content_Banner.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Banner.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '52',
                    title: 'Novo Banner',
                    title_lang: 'banner_new',
                    path: pathver ? '' : props.rotas.Content_Banner.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Banner.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '53',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Content_Banner.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Banner.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '60',
            title: 'Galeria',
            title_lang: 'galleries',
            path: pathver ? '' : props.rotas.Content_Gallery.list.endpoint,
            path_base: pathver ? '' : props.rotas.Content_Gallery.base,
            icon: 'images',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '61',
                    title: 'Lista de Galerias',
                    title_lang: 'galleries_list',
                    path: pathver ? '' : props.rotas.Content_Gallery.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Gallery.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '62',
                    title: 'Nova Galeria',
                    title_lang: 'gallery_new',
                    path: pathver ? '' : props.rotas.Content_Gallery.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Gallery.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '63',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Content_Gallery.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Gallery.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '70',
            title: 'Testemunhos',
            title_lang: 'testemonies',
            path: pathver ? '' : props.rotas.Content_Testemony.list.endpoint,
            path_base: pathver ? '' : props.rotas.Content_Testemony.base,
            icon: 'chat-quote',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '71',
                    title: 'Lista de Testemunhos',
                    title_lang: 'testemonies_list',
                    path: pathver ? '' : props.rotas.Content_Testemony.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Testemony.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '72',
                    title: 'Novo Testemunho',
                    title_lang: 'testemony_new',
                    path: pathver ? '' : props.rotas.Content_Testemony.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Testemony.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '73',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Content_Testemony.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Testemony.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '999',
            title: '',
            path: pathver ? ' ' : '/',
            icon: '',
            cName: 'list-divider',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: []
        },
        {
            id: '2001',
            title: 'Lista de Encomendas',
            title_lang: 'purchase_order',
            path: pathver ? ' ' : props.rotas.Estancia_PurchaseOrder.list.endpoint,
            icon: 'receipt',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: []
        },
        {
            id: '2005',
            title: 'Lista de Encomendas Pagas',
            title_lang: 'purchase_order_p',
            path: pathver ? ' ' : props.rotas.Estancia_PurchaseOrderPaied.list.endpoint,
            icon: 'receipt',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: []
        },
        {
            id: '2006',
            title: 'Lista de Encomendas Usadas',
            title_lang: 'purchase_order_u',
            path: pathver ? ' ' : props.rotas.Estancia_PurchaseOrderUsed.list.endpoint,
            icon: 'receipt',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: []
        },
        {
            id: '2007',
            title: 'Lista de Encomendas Não Usadas',
            title_lang: 'purchase_order_nu',
            path: pathver ? ' ' : props.rotas.Estancia_PurchaseOrderNotUsed.list.endpoint,
            icon: 'receipt',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: []
        },
        {
            id: '2002',
            title: 'Perfil de Cliente',
            title_lang: 'my_data',
            path: pathver ? ' ' : props.rotas.Cliente.regist.endpoint,
            icon: 'person-badge',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: []
        },
        {
            id: '2003',
            title: 'Perfil de Colaborador',
            title_lang: 'my_data',
            path: pathver ? ' ' : props.rotas.Colaborador.regist.endpoint,
            icon: 'person-badge',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: []
        },
        {
            id: '2004',
            title: 'Perfil de Instrutor',
            title_lang: 'my_data',
            path: pathver ? ' ' : props.rotas.Instrutor.regist.endpoint,
            icon: 'person-badge',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: []
        },
        {
            id: '2010',
            title: 'Produtos',
            title_lang: 'store_products',
            path: pathver ? '' : props.rotas.Store_Product.list.endpoint,
            path_base: pathver ? '' : props.rotas.Store_Product.base,
            icon: 'gift',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'store',
            show_submenu: false,
            submenu: [
                {
                    id: '2011',
                    title: 'Lista de produtos',
                    title_lang: 'store_products_list',
                    path: pathver ? '' : props.rotas.Store_Product.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Product.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2012',
                    title: 'Novo produto',
                    title_lang: 'store_product_new',
                    path: pathver ? '' : props.rotas.Store_Product.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Product.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2013',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Product.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Product.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '2020',
            title: 'Parametros',
            title_lang: 'store_parameters',
            path: pathver ? '' : props.rotas.Store_Category.list.endpoint,
            path_base: pathver ? '' : props.rotas.Store_Category.base,
            icon: 'gear-fill',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'store',
            show_submenu: true,
            submenu: [
                {
                    id: '2021',
                    title: 'Lista de Categorias',
                    title_lang: 'categories_list',
                    path: pathver ? '' : props.rotas.Store_Category.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2022',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Category.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2023',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Category.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2024',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Category_Value.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Category_Value.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2025',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Category_Value.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Category_Value.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2026',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Category_Value.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Category_Value.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2031',
                    title: 'Lista de Atributos',
                    title_lang: 'attributes_list',
                    path: pathver ? '' : props.rotas.Store_Attribute.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Attribute.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2032',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Attribute.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Attribute.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2033',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Attribute.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Attribute.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2034',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Attribute_Value.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Attribute_Value.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2035',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Attribute_Value.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Attribute_Value.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2036',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Attribute_Value.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Attribute_Value.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2041',
                    title: 'Lista de Caracteristicas',
                    title_lang: 'features_list',
                    path: pathver ? '' : props.rotas.Store_Feature.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Feature.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2042',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Feature.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Feature.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2043',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Feature.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Feature.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2044',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Feature_Value.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Feature_Value.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2045',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Feature_Value.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Feature_Value.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2046',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Feature_Value.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Feature_Value.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2051',
                    title: 'Lista de Marcas',
                    title_lang: 'brands_list',
                    path: pathver ? '' : props.rotas.Store_Brand.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Brand.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2052',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Brand.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Brand.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2053',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Brand.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Brand.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2054',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Brand_Value.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Brand_Value.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2055',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Brand_Value.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Brand_Value.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2056',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Brand_Value.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Brand_Value.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '2100',
            title: 'Shipping',
            title_lang: 'store_shipping',
            path: pathver ? '' : props.rotas.Store_Shipping_Carrier.list.endpoint,
            path_base: pathver ? '' : props.rotas.Store_Shipping_Carrier.base,
            icon: 'truck',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'store',
            show_submenu: true,
            submenu: [
                {
                    id: '2120',
                    title: 'Lista de Transportadoras',
                    title_lang: 'carrier_list',
                    path: pathver ? '' : props.rotas.Store_Shipping_Carrier.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Shipping_Carrier.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2121',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Shipping_Carrier.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Shipping_Carrier.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2122',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Shipping_Carrier.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Shipping_Carrier.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2111',
                    title: 'Lista de Zonas',
                    title_lang: 'zone_list',
                    path: pathver ? '' : props.rotas.Store_Shipping_Zone.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Shipping_Zone.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2112',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Shipping_Zone.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Shipping_Zone.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2113',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Shipping_Zone.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Shipping_Zone.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2114',
                    title: 'Lista de Países',
                    title_lang: 'country_list',
                    path: pathver ? '' : props.rotas.Store_Shipping_Country.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Shipping_Country.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2115',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Shipping_Country.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Shipping_Country.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2116',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Shipping_Country.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Shipping_Country.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2117',
                    title: 'Lista de taxas',
                    title_lang: 'taxe_list',
                    path: pathver ? '' : props.rotas.Store_Taxe.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Taxe.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2118',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Taxe.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Taxe.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '2119',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Store_Taxe.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Store_Taxe.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        
        
        /*{
            id: '3010',
            title: 'Projectos',
            title_lang: 'projects',
            path: pathver ? '' : props.rotas.Project.list.endpoint,
            path_base: pathver ? '' : props.rotas.Project.base,
            icon: 'gear-fill',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'projects',
            show_submenu: false,
            submenu: [
                {
                    id: '3011',
                    title: 'Lista de Projectos',
                    title_lang: 'projects_list',
                    path: pathver ? '' : props.rotas.Project.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Project.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3012',
                    title: 'Novo Projecto',
                    title_lang: 'project_new',
                    path: pathver ? '' : props.rotas.Project.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Project.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3013',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Project.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Project.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '3020',
            title: 'Parametros',
            title_lang: 'project_parameters',
            path: pathver ? '' : props.rotas.Project_Area.list.endpoint,
            path_base: pathver ? '' : props.rotas.Project_Area.base,
            icon: 'gear-fill',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'projects',
            show_submenu: true,
            submenu: [
                {
                    id: '3021',
                    title: 'Lista de Ýreas',
                    title_lang: 'project_areas',
                    path: pathver ? '' : props.rotas.Project_Area.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Project_Area.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3022',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Project_Area.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Project_Area.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3023',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Project_Area.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Project_Area.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3024',
                    title: 'Lista de Programas',
                    title_lang: 'project_programs',
                    path: pathver ? '' : props.rotas.Project_Program.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Project_Program.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3025',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Project_Program.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Project_Program.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3026',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Project_Program.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Project_Program.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3027',
                    title: 'Lista de Dominios',
                    title_lang: 'project_domains',
                    path: pathver ? '' : props.rotas.Project_Domain.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Project_Domain.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3028',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Project_Domain.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Project_Domain.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3029',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Project_Domain.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Project_Domain.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3030',
                    title: 'Lista de Ambitos',
                    title_lang: 'project_scopes',
                    path: pathver ? '' : props.rotas.Project_Scope.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Project_Scope.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3031',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Project_Scope.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Project_Scope.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3032',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Project_Scope.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Project_Scope.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3033',
                    title: 'Lista de Fundos',
                    title_lang: 'project_funds',
                    path: pathver ? '' : props.rotas.Project_Fund.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Project_Fund.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3034',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Project_Fund.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Project_Fund.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3035',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Project_Fund.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Project_Fund.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },*/

        {
            id: '3120',
            title: 'Estância',
            title_lang: 'estancia',
            path: pathver ? '' : props.rotas.Estancia_Config.regist.endpoint,
            path_base: pathver ? '' : props.rotas.Estancia_Config.base,
            icon: 'snow',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'estancia',
            show_submenu: true,
            submenu: [
                {
                    id: '3121',
                    title: 'Estancia_config',
                    title_lang: 'estancia_config',
                    path: pathver ? '' : props.rotas.Estancia_Config.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Config.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3148',
                    title: 'Marcação de Aulas',
                    title_lang: 'estancia_aulas',
                    path: pathver ? '' : props.rotas.Estancia_Aula.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Aula.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3149',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Aula.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Aula.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3150',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Aula.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Aula.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },

        {
            id: '3220',
            title: 'Parâmetros',
            title_lang: 'estancia_parametros',
            path: pathver ? '' : props.rotas.Estancia_Meios.list.endpoint,
            path_base: pathver ? '' : props.rotas.Estancia_Meios.base,
            icon: 'gear-fill',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'estancia_parametros',
            show_submenu: true,
            submenu: [
                {
                    id: '3124',
                    title: 'Lista de Meios',
                    title_lang: 'estancia_meios',
                    path: pathver ? '' : props.rotas.Estancia_Meios.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Meios.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3125',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Meios.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Meios.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3126',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Meios.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Meios.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3127',
                    title: 'Lista Pistas',
                    title_lang: 'estancia_pistas',
                    path: pathver ? '' : props.rotas.Estancia_Pista.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Pista.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3128',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Pista.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Pista.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3129',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Pista.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Pista.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3142',
                    title: 'Lista Instrutores',
                    title_lang: 'estancia_instrutores',
                    path: pathver ? '' : props.rotas.Instrutor.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Instrutor.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3143',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Instrutor.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Instrutor.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3144',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Instrutor.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Instrutor.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3145',
                    title: 'Lista Zonas',
                    title_lang: 'estancia_zonas',
                    path: pathver ? '' : props.rotas.Estancia_Zona.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Zona.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3146',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Zona.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Zona.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3147',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Zona.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Zona.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3158',
                    title: 'Lista Colaboradores',
                    title_lang: 'estancia_colaboradores',
                    path: pathver ? '' : props.rotas.Colaborador.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Colaborador.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3159',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Colaborador.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Colaborador.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3160',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Colaborador.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Colaborador.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
            ]
        },

        {
            id: '3320',
            title: 'Produtos',
            title_lang: 'estancia_produtos',
            path: pathver ? '' : props.rotas.Estancia_Forfait.list.endpoint,
            path_base: pathver ? '' : props.rotas.Estancia_Forfait.base,
            icon: 'gift',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'estancia_produtos',
            show_submenu: true,
            submenu: [
                {
                    id: '3130',
                    title: 'Lista Forfaits',
                    title_lang: 'estancia_forfaits',
                    path: pathver ? '' : props.rotas.Estancia_Forfait.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Forfait.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3131',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Forfait.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Forfait.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3132',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Forfait.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Forfait.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3133',
                    title: 'Lista Equipamentos',
                    title_lang: 'estancia_equipamentos',
                    path: pathver ? '' : props.rotas.Estancia_Equipamento.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Equipamento.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3134',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Equipamento.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Equipamento.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3135',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Equipamento.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Equipamento.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3136',
                    title: 'Lista Vouchers',
                    title_lang: 'estancia_vouchers',
                    path: pathver ? '' : props.rotas.Estancia_Voucher.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Voucher.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3137',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Voucher.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Voucher.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3138',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Voucher.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Voucher.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3139',
                    title: 'Lista Packs',
                    title_lang: 'estancia_packs',
                    path: pathver ? '' : props.rotas.Estancia_Pack.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Pack.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3140',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Pack.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Pack.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3141',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Pack.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Pack.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3154',
                    title: 'Lista Atividades',
                    title_lang: 'estancia_activities',
                    path: pathver ? '' : props.rotas.Estancia_Atividade.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Atividade.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3155',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Atividade.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Atividade.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3156',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_Atividade.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_Atividade.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3151',
                    title: 'Lista Aulas',
                    title_lang: 'estancia_aulas_info',
                    path: pathver ? '' : props.rotas.Estancia_AulaInfo.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_AulaInfo.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3152',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_AulaInfo.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_AulaInfo.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '3153',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Estancia_AulaInfo.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Estancia_AulaInfo.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },




        {
            id: '1010',
            title: 'Perfis',
            title_lang: 'perfis',
            path: pathver ? ' ' : props.rotas.Perfil.list.endpoint,
            show_submenu: false,
            icon: 'person-badge',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: [
                {
                    id: '1011',
                    title: 'Lista de Perfis',
                    title_lang: 'lista_perfis',
                    path: pathver ? ' ' : props.rotas.Perfil.list.endpoint,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1012',
                    title: 'Novo Perfil',
                    title_lang: 'novo',
                    path: pathver ? ' ' : props.rotas.Perfil.regist.endpoint,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1013',
                    title: '',
                    path: pathver ? ' ' : props.rotas.Perfil.view.endpoint,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },

            ]
        },
        {
            id: '1020',
            title: 'Utilizador',
            title_lang: 'webuser',
            path: pathver ? '' : props.rotas.Utilizador.list.endpoint,
            path_base: pathver ? '' : props.rotas.Utilizador.base,
            icon: 'people',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '1021',
                    title: 'Lista de Utilizadores',
                    title_lang: 'webuser_list',
                    path: pathver ? '' : props.rotas.Utilizador.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Utilizador.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1022',
                    title: 'Inserir Utilizador',
                    title_lang: 'webuser_new',
                    path: pathver ? '' : props.rotas.Utilizador.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Utilizador.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1023',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Utilizador.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Utilizador.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '1024',
            title: 'Cliente',
            title_lang: 'client',
            path: pathver ? '' : props.rotas.Cliente.list.endpoint,
            path_base: pathver ? '' : props.rotas.Cliente.base,
            icon: 'people',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '1025',
                    title: 'Lista de Cliente',
                    title_lang: 'client_list',
                    path: pathver ? '' : props.rotas.Cliente.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Cliente.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1026',
                    title: 'Inserir Cliente',
                    title_lang: 'client_new',
                    path: pathver ? '' : props.rotas.Cliente.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Cliente.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1027',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Cliente.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Cliente.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '1028',
            title: 'Empresa',
            title_lang: 'company',
            path: pathver ? '' : props.rotas.Company.components.base.path,
            path_base: pathver ? '' : props.rotas.Company.components.base.path,
            icon: 'people',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: []
        },
        {
            id: '1040',
            title: 'Calendário',
            title_lang: 'calendar',
            path: pathver ? '' : props.rotas.Calendar_Category.list.endpoint,
            path_base: pathver ? '' : props.rotas.Calendar_Category.base,
            icon: 'calendar3',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '1041',
                    title: 'Lista de Categorias',
                    title_lang: 'categories_list',
                    path: pathver ? '' : props.rotas.Calendar_Category.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Calendar_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1042',
                    title: 'Inserir Categoria',
                    title_lang: 'category_new',
                    path: pathver ? '' : props.rotas.Calendar_Category.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Calendar_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1043',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Calendar_Category.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Calendar_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '1030',
            title: 'Menus',
            title_lang: 'menus',
            path: pathver ? '' : props.rotas.Structure.list.endpoint,
            path_base: pathver ? '' : props.rotas.Structure.base,
            icon: 'diagram-3',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '1031',
                    title: 'Lista de Menus',
                    title_lang: 'menus_list',
                    path: pathver ? '' : props.rotas.Structure.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Structure.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1032',
                    title: 'Inserir Menu',
                    title_lang: 'menu_new',
                    path: pathver ? '' : props.rotas.Structure.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Structure.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1033',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Structure.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Structure.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        {
            id: '1050',
            title: 'Categorias',
            title_lang: 'categories',
            path: pathver ? '' : props.rotas.Content_Category.list.endpoint,
            path_base: pathver ? '' : props.rotas.Content_Category.base,
            icon: 'tags',
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            module: 'website',
            show_submenu: false,
            submenu: [
                {
                    id: '1051',
                    title: 'Lista de Categorias',
                    title_lang: 'categories_list',
                    path: pathver ? '' : props.rotas.Content_Category.list.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1052',
                    title: 'Inserir Categoria',
                    title_lang: 'category_new',
                    path: pathver ? '' : props.rotas.Content_Category.regist.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                },
                {
                    id: '1053',
                    title: '',
                    title_lang: '',
                    path: pathver ? '' : props.rotas.Content_Category.view.endpoint,
                    path_base: pathver ? '' : props.rotas.Content_Category.base,
                    icon: '',
                    cName: '',
                    allow: true,
                    create: true,
                    edit: true,
                    view: true,
                    remove: true,
                    submenu: []
                }
            ]
        },
        

      
    ]

}